import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const getProduct = () => client.get("/product").then((r) => r.data);
export const createCheckout = (items) =>
  client.post("/checkout/session", { items, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  client.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const submitContact = (data) => client.post("/contact", data).then((r) => r.data);

export const eur = (cents) =>
  (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
